<div class="card-header border-0">
    <div class="separator"></div>
    <div class="mr-auto">	
        <h4 class="text-black fs-20">{{title}}</h4>
        <p class="fs-13 mb-0">{{subTitle}}</p>
    </div>	
</div>